import SDInput from '@cas-smartdesign/lit-input';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { updateTenantAttribute } from '../../tenant-attribute/update-tenant-attribute';
import { i18n } from '../../utils/i18n/i18n';

@customElement('as-mfa-enforcement-settings')
export class MfaEnforcementSettings extends LitElement {
  static styles = css`
    sd-lit-input {
      width: 100%;
    }
  `;

  @property({ type: Boolean })
  private mfaEnforced = false;

  @property()
  private mfaEnforcementGracePeriod = this.getCurrentDateString();

  private sdInputRef = createRef<SDInput>();
  private isMfaEnforcementStateInitialized = false;

  render() {
    return html` <as-widget-group caption="${i18n('admin.mfa.enforcementSettingsCaption')}">
      <as-vertical-layout>
        <div>${i18n('admin.mfa.enforcementSettingsDescription')}</div>
        <sd-radio-button-group layout="horizontal" @value-change=${this.handleStatusChange}>
          <as-segmented-button value="true" ?checked=${this.mfaEnforced}>
            ${i18n('common.active')}
          </as-segmented-button>
          <as-segmented-button value="false" ?checked=${!this.mfaEnforced}>
            ${i18n('common.inactive')}
          </as-segmented-button>
        </sd-radio-button-group>
        <sd-lit-input
          ${ref(this.sdInputRef)}
          id="mfa-enforcement-grace-period"
          type="date"
          label="${i18n('admin.mfa.enforcementGracePeriod')}"
          value="${this.mfaEnforcementGracePeriod}"
          min="${this.getCurrentDateString()}"
          max="9999-12-31"
          ?disabled=${!this.mfaEnforced}
          @value-change=${this.handleDatePickerChange}
        ></sd-lit-input>
      </as-vertical-layout>
    </as-widget-group>`;
  }

  private async handleDatePickerChange(event: CustomEvent<{ value: string }>) {
    if (this.isValidInput()) {
      const updatedGracePeriod = event.detail.value;
      await updateTenantAttribute('mfaEnforcementGracePeriod', updatedGracePeriod === '' ? null : updatedGracePeriod);
    }
  }

  private isValidInput() {
    return this.sdInputRef.value?.value === '' || this.sdInputRef.value?.matches(':valid');
  }

  private async handleStatusChange(event: CustomEvent<{ value: string }>) {
    if (!this.isMfaEnforcementStateInitialized) {
      this.isMfaEnforcementStateInitialized = true;
      return;
    }
    this.mfaEnforced = 'true' == event.detail.value;
    await updateTenantAttribute('mfaEnforced', event.detail.value);
  }

  private getCurrentDateString() {
    return new Date().toISOString().slice(0, 10);
  }
}
